/**
 * Layout host: FAB on bound pages only; dock when open; hide entirely elsewhere.
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useOperationsPane } from './operationsContext';
import { isOperationsBoundPath } from './pageBind';
import { OperationsFab } from './OperationsFab';
import { OperationsPane } from './OperationsPane';

export const OperationsHost: React.FC = () => {
  const location = useLocation();
  const { canUse, isOpen, setOpen } = useOperationsPane();
  const bound = isOperationsBoundPath(location.pathname);

  useEffect(() => {
    if (!bound && isOpen) {
      setOpen(false);
    }
  }, [bound, isOpen, setOpen]);

  if (!canUse || !bound) return null;
  if (isOpen) return <OperationsPane />;
  return <OperationsFab />;
};
